module.exports = __webpack_public_path__ + "img/gps_ios_safari.7695a80f.jpg";